import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutDashboard, FileUp, Users, LogOut, Settings } from 'lucide-react';
import { auth } from '../../firebase/config';
import { signOut } from 'firebase/auth';
import {
  NavContainer,
  NavHeader,
  NavList,
  NavItem,
  StyledNavLink,
  LogoutButton
} from './SideNav.styles';
import ThemeToggleButton from '../common/ThemeToggleButton';
import { BottomControls } from './SideNav.styles';

const navLinks = {
  admin: [
    { to: '/admin/dashboard', icon: <LayoutDashboard size={20} />, text: 'Dashboard' },
    { to: '/admin/users', icon: <Users size={20} />, text: 'Manage Users' },
    { to: '/admin/settings', icon: <Settings size={20} />, text: 'Settings' },
  ],
  'data-entry': [
    { to: '/data-entry/dashboard', icon: <LayoutDashboard size={20} />, text: 'Dashboard' },
    { to: '/data-entry/uploads', icon: <FileUp size={20} />, text: 'View Uploads' },
  ],
  client: [
    { to: '/client/dashboard', icon: <LayoutDashboard size={20} />, text: 'Dashboard' },
    { to: '/client/upload', icon: <FileUp size={20} />, text: 'Upload Docs' },
    { to: '/client/settings', icon: <Settings size={20} />, text: 'Settings' }, // <-- FIX: This line was missing
  ],
};

const SideNav = ({ userRole, isOpen, toggleTheme, currentTheme }) => {
  const navigate = useNavigate();
  const links = navLinks[userRole] || [];

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/login');
  };

  return (
    <NavContainer $isOpen={isOpen}> 
      <NavHeader>TallyDocs</NavHeader>
      <NavList>
        {links.map(link => (
          <NavItem key={link.to}>
            <StyledNavLink to={link.to}>
              {link.icon}
              {link.text}
            </StyledNavLink>
          </NavItem>
        ))}
      </NavList>
      <BottomControls>
        <LogoutButton onClick={handleLogout}>
          <LogOut size={20} />
          Logout
        </LogoutButton>
        <ThemeToggleButton theme={currentTheme} toggleTheme={toggleTheme} />
      </BottomControls>
    </NavContainer>
  );
};

export default SideNav;